"use strict";

import Vue from 'vue';
import axios from "axios";
import QS from 'qs'
import { Message } from 'element-ui'
import { decryptWithSignature } from "@/util";

const _axios = axios.create();

_axios.interceptors.request.use(
  function (config) {
    const url = window.location.href
    const params = new URL(url).searchParams
    const batchId = decryptWithSignature(params.get('batchId'))
    if (config.method === 'post') {
      config.url += '/' + process.env.VUE_APP_TENANTID + '/' + process.env[batchId]
    } else if (config.method === 'get') {
      config.url = config.url.split('?')[0] + '/' + process.env.VUE_APP_TENANTID + '/' + process.env[batchId] + (config.url.split('?')[1] ? '?' + config.url.split('?')[1] : '')
      const params = QS.parse(config.url.split('?')[1])
      params.timestamp = new Date().getTime() + ''
      config.url = config.url.split('?')[0] + `?${QS.stringify(params)}`
    }
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    if (response.data.code === '1000000') {
      return response.data;
    } else {
      Message({
        type: 'error',
        message: response.data.msg,
        showClose: true,
        duration: 5000
      })
      return response.data;
    }
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function (Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get () {
        return _axios;
      }
    },
    $axios: {
      get () {
        return _axios;
      }
    }
  });
};

Vue.use(Plugin)

export default Plugin;
